import Vue from 'vue'
import axios from 'axios'

export default {

  async addRoom(id){

    let rooms = JSON.parse(localStorage.getItem("rooms"))

    if(rooms){
      if(rooms.indexOf(id) < 0){
        rooms.push(id)
        localStorage.setItem("rooms",JSON.stringify(rooms))
      }
    }else{
      localStorage.setItem("rooms",JSON.stringify([id]))
    }

  },

  async removeRoom(id){

    let rooms = JSON.parse(localStorage.getItem("rooms"))

    if(rooms){
      const index = rooms.indexOf(id);
      if(index > -1){
        rooms.splice(index, 1);
        localStorage.setItem("rooms",JSON.stringify(rooms))
      }
    }

  },

  async joinRooms(self){
    
    let rooms = JSON.parse(localStorage.getItem("rooms"))
    if(rooms){
      for (const x of rooms) {
        self.$socket.emit("join_room", {
          room: x
        });        
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/videoconsulta/rooms.js